import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import styles from './AttendanceChart.module.scss';
import {AttendanceChartProps} from "../../types/types";

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  data
}: {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
  index: number;
  data: any;
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#000000"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontWeight="bold"
      fontSize={12}
    >
      {`${data[index].value}`}
    </text>
  );
};

const renderCustomLegend = (props: any) => {
  const { payload } = props;
  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'center' }}>
      {payload.map((entry: { color: any; value: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; payload: { name: string | number | bigint | boolean | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Promise<string | number | bigint | boolean | React.ReactPortal | React.ReactElement<unknown, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | null | undefined> | null | undefined; }; }, index: any) => (
        <li key={`item-${index}`} style={{ marginBottom: 4, display: 'inline-block', marginRight: 10, fontSize: 10, lineHeight: '12px' }}>
          <span
            style={{
              display: 'inline-block',
              marginRight: 4,
              width: 12,
              height: 12,
              backgroundColor: entry.color,
              borderRadius: '50%',
              verticalAlign: 'top',
            }}
          />
          <span style={{ fontWeight: 'bold', color: '#555' }}> {entry.payload.name}</span>
        </li>
      ))}
    </ul>
  );
};

const AttendanceChart: React.FC<AttendanceChartProps> = ({data}) => {
  const COLORS = data.map((entry: any) => entry.color);
  const totalValue = data.reduce((sum:number, item:any) => sum + item.value, 0);
  return (
    <Card className={styles.chartCard}>
      <CardContent>
        <Box className={styles.header}>
          <Typography variant="h6" className={styles.title}>
            Students by State
          </Typography>
          <MoreVertIcon sx={{ color: 'var(--mui-palette-text-secondary)' }} />
        </Box>

        <Box className={styles.chartWrapper}>
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
              <Pie
                data={data}
      
   
  
                // label={renderCustomizedLabel}
                label
                cx="50%"
                cy="50%"
                innerRadius={70}
                outerRadius={130}
                fill="#8884d8"
                paddingAngle={0}
                dataKey="value"
                startAngle={90}
                endAngle={450}
              >
                {data.map((_:any, index:number) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
               <text
                x="50%"
                y="46%"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="bold"
                fontSize={32}
                fill="#555"
              >
                {totalValue}
              </text>
              <Tooltip />
              <Legend verticalAlign="bottom" content={renderCustomLegend} />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AttendanceChart;